import type { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

type TicketDetailsLoaderVariantT = 'details' | 'messages' | 'attachments';

interface TicketDetailsLoaderPropsT {
  variant?: TicketDetailsLoaderVariantT;
}

const DetailsShimmer: FC<{ bg: string; fg: string }> = ({ bg, fg }) => (
  <ContentLoader
    speed={2}
    width="100%"
    height={300}
    backgroundColor={bg}
    foregroundColor={fg}
    style={{ display: 'block', width: '100%' }}
  >
    <rect x="16" y="20" rx="4" ry="4" width="70%" height="14" />
    <rect x="16" y="50" rx="4" ry="4" width="55%" height="14" />
    <rect x="16" y="80" rx="4" ry="4" width="60%" height="14" />
    <rect x="16" y="116" rx="6" ry="6" width="90%" height="160" />
  </ContentLoader>
);

const MessagesShimmer: FC<{ bg: string; fg: string }> = ({ bg, fg }) => (
  <ContentLoader
    speed={2}
    width="100%"
    height={300}
    backgroundColor={bg}
    foregroundColor={fg}
    style={{ display: 'block', width: '100%' }}
  >
    <rect x="16" y="16" rx="6" ry="6" width="90%" height="80" />
    <rect x="16" y="110" rx="6" ry="6" width="90%" height="80" />
    <rect x="16" y="204" rx="6" ry="6" width="90%" height="80" />
  </ContentLoader>
);

const AttachmentsShimmer: FC<{ bg: string; fg: string }> = ({ bg, fg }) => (
  <ContentLoader
    speed={2}
    width="100%"
    height={300}
    backgroundColor={bg}
    foregroundColor={fg}
    style={{ display: 'block', width: '100%' }}
  >
    <rect x="16" y="12" rx="4" ry="4" width="90%" height="32" />
    <rect x="16" y="54" rx="4" ry="4" width="90%" height="32" />
    <rect x="16" y="96" rx="4" ry="4" width="90%" height="32" />
    <rect x="16" y="138" rx="4" ry="4" width="90%" height="32" />
    <rect x="16" y="180" rx="4" ry="4" width="90%" height="32" />
    <rect x="16" y="222" rx="4" ry="4" width="90%" height="32" />
  </ContentLoader>
);

const TicketDetailsLoader: FC<TicketDetailsLoaderPropsT> = ({ variant = 'details' }) => {
  const theme = useTheme();
  const bg = theme.colors.surface;
  const fg = theme.colors.primary.variant6;

  if (variant === 'messages') return <MessagesShimmer bg={bg} fg={fg} />;
  if (variant === 'attachments') return <AttachmentsShimmer bg={bg} fg={fg} />;
  return <DetailsShimmer bg={bg} fg={fg} />;
};

export default TicketDetailsLoader;
